import React, { useState, useEffect } from 'react';
import { Spin, Empty, Table, Alert, Space, Card, Typography, Divider } from 'antd';
import { baseUrl_SPB } from '../../../BaseUrl';

import { useAuth } from '../../../AuthProvider';
import FetchRosterAllocationService from '../../../roster/FetchRosterAllocationService';
const { Text } = Typography;
const WorkHoursPanel = ({ employeeId, employeeName, token }) => {
  const [stats, setStats] = useState(null);
  const resourceId = employeeId;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [bookedItems, setBookedItems] = useState([]);
  const authContext = useAuth();
  useEffect(() => {
        FetchRosterAllocationService(authContext.token).then((response) => {
                       if (response) {
                          // console.log('booked items from Roster main', response);
                           setBookedItems(response);
                       }
                   });
    }, [authContext.token]);
  
  
    const formatDateLabel = (dateStr) => {
        const date = new Date(dateStr);
        const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${weekday} ${dd}-${mm}-${yyyy}`;
    };

    const formatDateLabelWithoutWeekDay = (dateStr) => {
        const date = new Date(dateStr);
        const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${dd}-${mm}-${yyyy}`;
    };
    function parseDateFromDDMMYYYY(dateStr) {
        const [day, month, year] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day); // Note: month is 0-based in JS
    }
    
    const filterApprovedItems = (status, items) => {
        return items.filter((item) => {
            const isApproved = (status === 'approved') && item.status === 'timesheet' && item.approvalStatus === 'approved';
            if (status) {
                return (
                    (isApproved)
                );
            }
        });
    }
    
    const constructTime = (dateStr, timeStr) => {

        // Split the date string into day, month, and year
        const [year, month, day] = dateStr.split('-');

        // Parse the time string using a Date object
        const time = new Date(`1970-01-01T${timeStr}`);

        // Extract hours and minutes from the parsed time
        const hours = time.getHours();
        const minutes = time.getMinutes();

        // Construct the final Date object
        return new Date(year, month - 1, day, hours, minutes);

    }
    
    const getPreviousWeekBookedItems = (bookedItems) => {
        // Get today's date
        const today = new Date();

        // Calculate the start of this week (assuming the week starts on Sunday)
        const startOfThisWeek = new Date(today);
        startOfThisWeek.setDate(today.getDate() - today.getDay());

        // Calculate the start of the previous week
        const startOfPreviousWeek = new Date(startOfThisWeek);
        startOfPreviousWeek.setDate(startOfThisWeek.getDate() - 7);

        // Create an array of the seven days of the previous week
        const previousWeekDates = [];
        for (let i = 0; i < 7; i++) {
            const day = new Date(startOfPreviousWeek);
            day.setDate(startOfPreviousWeek.getDate() + i);
            previousWeekDates.push(formatDateLabelWithoutWeekDay(day.toISOString().split('T')[0])); // Format as YYYY-MM-DD
        }

        // Group booked items by date
        const groupedBookedItems = groupBookedItemsByDate(bookedItems);

        // Create a grouped object for the previous week
        const previousWeekGroupedItems = {};
        previousWeekDates.forEach((date) => {
            previousWeekGroupedItems[date] = groupedBookedItems[date] || []; // Use an empty array if no items exist for the date
        });

        return previousWeekGroupedItems;
    };


    const applyBreakDeduction = (hoursWorked) => {
        if (hoursWorked <= 5) return hoursWorked;
        const breaks = Math.floor(hoursWorked / 5) * 0.5;
        return hoursWorked - breaks;
    };
    
    const groupBookedItemsByDate = (bookedItems) => {
        return bookedItems.reduce((grouped, item) => {
            const { date } = item; // Extract the date property
            if (!grouped[date]) {
                grouped[date] = []; // Initialize an array for this date if it doesn't exist
            }
            grouped[date].push(item); // Add the item to the corresponding date group
            return grouped;
        }, {}); // Start with an empty object
    };

    const calculateTotalHours = (resourceId, status) => {
        const today = new Date();
        const last7Days = [];

        // Calculate the last 7 days
        for (let i = 0; i < 7; i++) {
            const day = new Date(today);
            day.setDate(today.getDate() - i);
            last7Days.push(formatDateLabelWithoutWeekDay(day.toISOString().split('T')[0]));
        }

        // Filter booked items for the resource in the last 7 days
        let last7DaysItems = bookedItems.filter(
            (item) => item.staffId === resourceId && last7Days.includes(item.date)
        );

        if (status) {
            last7DaysItems = filterApprovedItems(status, last7DaysItems);
        }
        // Calculate total hours worked with break deduction
        const totalHours = last7DaysItems.reduce((sum, item) => {
            if (!item.starttime || !item.endtime) return sum;

            const start = constructTime(item.date, item.starttime);
            const end = constructTime(item.date, item.endtime);

            let hoursWorked = (end - start) / (1000 * 60 * 60);
            hoursWorked = applyBreakDeduction(hoursWorked);

            return sum + hoursWorked;
        }, 0);

        return totalHours.toFixed(2); // Return total hours rounded to 2 decimal places
    };

    const calculateTotalHoursForPreviousWeek = (resourceId, status) => {
        const previousWeekBookedItems = getPreviousWeekBookedItems(bookedItems);

        // Flatten the booked items for the previous week
        const allPreviousWeekItems = Object.values(previousWeekBookedItems).flat();

        // Filter booked items for the specific resource
        let resourceItems = allPreviousWeekItems.filter(item => item.staffId === resourceId);

        // Filter approved items if status is provided
        if (status) {
            resourceItems = filterApprovedItems(status, resourceItems);
        }
        // Calculate total hours worked with break deduction
        const totalHours = resourceItems.reduce((sum, item) => {
            if (!item.starttime || !item.endtime) return sum;

            const start = constructTime(item.date, item.starttime);
            const end = constructTime(item.date, item.endtime);

            let hoursWorked = (end - start) / (1000 * 60 * 60);
            hoursWorked = applyBreakDeduction(hoursWorked);

            return sum + hoursWorked;
        }, 0);

        return totalHours.toFixed(2); // Return total hours rounded to 2 decimal places
    };


    const calculateTotalHoursForLastMonth = (resourceId, status) => {
        const today = new Date();
        const startOfMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const endOfMonth = new Date(today.getFullYear(), today.getMonth(), 0);

        const lastMonthItems = bookedItems.filter(
            (item) => {

                const isApproved = (status === 'approved') && item.status === 'timesheet' && item.approvalStatus === 'approved';
                const itemDate = new Date(parseDateFromDDMMYYYY(item.date));
                if (status) {
                    return (
                        item.staffId === resourceId &&
                        itemDate >= startOfMonth &&
                        itemDate <= endOfMonth &&
                        (isApproved)
                    );
                }
                return (
                    item.staffId === resourceId &&
                    itemDate >= startOfMonth &&
                    itemDate <= endOfMonth

                );
            }
        );

        const totalHours = lastMonthItems.reduce((sum, item) => {
            if (!item.starttime || !item.endtime) return sum;

            const start = constructTime(item.date, item.starttime);
            const end = constructTime(item.date, item.endtime);

            let hoursWorked = (end - start) / (1000 * 60 * 60);
            hoursWorked = applyBreakDeduction(hoursWorked);

            return sum + hoursWorked;
        }, 0);

        return totalHours.toFixed(2); // Round to 2 decimal places
    };


    const calculateTotalHoursForThisMonth = (resourceId) => {
        const today = new Date();
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        const thisMonthItems = bookedItems.filter((item) => {
            const itemDate = new Date(parseDateFromDDMMYYYY(item.date));
            return (
                item.staffId === resourceId &&
                itemDate >= startOfMonth &&
                itemDate <= endOfMonth
            );
        });

        const totalHours = thisMonthItems.reduce((sum, item) => {
            if (!item.starttime || !item.endtime) return sum;

            const start = constructTime(item.date, item.starttime);
            const end = constructTime(item.date, item.endtime);

            let hoursWorked = (end - start) / (1000 * 60 * 60);
            hoursWorked = applyBreakDeduction(hoursWorked);
            return sum + hoursWorked;
        }, 0);

        return totalHours.toFixed(2);
    };

     const totalHours = calculateTotalHours(resourceId) || 0;
        const totalApprovedHours = calculateTotalHours(resourceId, 'approved');
        const totalHoursForPreviousWeek = calculateTotalHoursForPreviousWeek(resourceId);
        const totalApprovedHoursForPreviousWeek = calculateTotalHoursForPreviousWeek(resourceId, 'approved');
        const totalHoursForLastMonth = calculateTotalHoursForLastMonth(resourceId);
        const totalApprovedHoursForLastMonth = calculateTotalHoursForLastMonth(resourceId, 'approved');
        const totalHoursForThisMonth = calculateTotalHoursForThisMonth(resourceId);
        const totalApprovedHoursForThisMonth = calculateTotalHoursForThisMonth(resourceId, 'approved');
 

  return (
    <Spin spinning={loading}>
      {error && <Alert type="error" showIcon message={error} closable />}
      
      {!totalHours ? (
        <Empty description="No work hours data available" />
      ) : (
        <Space direction="vertical" style={{ width: '100%' }} size={16}>
          <Card style={{ backgroundColor: '#fafafa' }}>
            <Space direction="vertical" style={{ width: '100%' }} size={12}>
              <div>
                <Text>
                  <strong>{employeeName}</strong> combined work hours is{' '}
                  <strong>{(totalHours)} hours</strong> in the last 7 days.
                </Text>
              </div>

              <Divider style={{ margin: '8px 0' }} />

              <div>
                <Text strong style={{ display: 'block', marginBottom: 4 }}>
                  Total hours for previous week (Sun-Sat):
                </Text>
                <Text>{totalHoursForPreviousWeek}</Text>
              </div>

              <div>
                <Text strong style={{ display: 'block', marginBottom: 4 }}>
                  Total hours for last month:
                </Text>
                <Text>{totalHoursForLastMonth}</Text>
              </div>

              <div>
                <Text strong style={{ display: 'block', marginBottom: 4 }}>
                  Total hours planned for this month:
                </Text>
                <Text>{totalHoursForThisMonth}</Text>
              </div>

              <Divider style={{ margin: '8px 0' }} />

              <div>
                <Text>
                  <strong>{employeeName}</strong> worked a total of{' '}
                  <strong>{totalApprovedHours} approved hours</strong> in the last 7 days.
                </Text>
              </div>

              <div>
                <Text strong style={{ display: 'block', marginBottom: 4 }}>
                  Total approved hours for previous week (Sun-Sat):
                </Text>
                <Text>{totalApprovedHoursForPreviousWeek}</Text>
              </div>

              <div>
                <Text strong style={{ display: 'block', marginBottom: 4 }}>
                  Total approved hours for last month:
                </Text>
                <Text>{totalApprovedHoursForLastMonth}</Text>
              </div>
            </Space>
          </Card>
        </Space>
      )}
    </Spin>
  );
};

export default WorkHoursPanel;
